import React from "react";
import { Container } from "../../../components/core/03-base/Container";
import { FlexRow } from "../../../components/core/03-base/Flex/Row";
import { Div } from "../../../components/core/03-base/Div";
import { getCurrentEnv, getCurrentEnvLabel } from "../../../utils/WhichEnv";
import * as I18n from "../../../utils/translations/I18n";
export var EnvIndicatorBar = function () {
    if (getCurrentEnv() === "prod") {
        return null;
    }
    // eslint-disable-next-line max-len
    var getEnv = React.createElement("span", null,
        I18n.getText("mary.06-molecules.env-indicator-bar-prefix", "You are currently on the"),
        " ",
        React.createElement("span", { className: "scl-a-badge scl-a-badge--contrast-primary" }, getCurrentEnvLabel()),
        " ",
        I18n.getText("mary.06-molecules.env-indicator-bar-postfix", "environment"));
    return (React.createElement(FlexRow, { isFixed: true },
        React.createElement(Div, { className: "scl-m-env-indicator" },
            React.createElement(Container, { theme: {
                    padding: {
                        "": { y: 1 },
                        "sm": { y: 1 },
                    },
                }, className: "scl-m-env-indicator__content" }, getEnv))));
};
